export default {
	api: {
		operationSuccess: 'Operation Success',
		operationFailed: 'Operation failed',
		errorTip: 'Error Tip',
		successTip: 'Success Tip',
		errorMessage: 'The operation failed, the system is abnormal!',
		timeoutMessage: 'Login timed out, please log in again!',
		apiTimeoutMessage: 'The interface request timed out, please refresh the page and try again!',
		apiRequestFailed: 'The interface request failed, please try again later!',
		networkException: 'network anomaly',
		networkExceptionMsg: 'Please check if your network connection is normal! The network is abnormal',

		errMsg401: 'The user does not have permission (token, user name, password error)!',
		errMsg403: 'The user is authorized, but access is forbidden!',
		errMsg404: 'Network request error, the resource was not found!',
		errMsg405: 'Network request error, request method not allowed!',
		errMsg408: 'Network request timed out!',
		errMsg500: 'Server error, please contact the administrator!',
		errMsg501: 'The network is not implemented!',
		errMsg502: 'Network Error!',
		errMsg503: 'The service is unavailable, the server is temporarily overloaded or maintained!',
		errMsg504: 'Network timeout!',
		errMsg505: 'The http version does not support the request!',
	},
	app: {
		logoutTip: 'Reminder',
		logoutMessage: 'Confirm to exit the system?',
		menuLoading: 'Menu loading...',
	},
	errorLog: {
		tableTitle: 'Error log list',
		tableColumnType: 'Type',
		tableColumnDate: 'Time',
		tableColumnFile: 'File',
		tableColumnMsg: 'Error message',
		tableColumnStackMsg: 'Stack info',

		tableActionDesc: 'Details',

		modalTitle: 'Error details',

		fireVueError: 'Fire vue error',
		fireResourceError: 'Fire resource error',
		fireAjaxError: 'Fire ajax error',

		enableMessage: 'Only effective when useErrorHandle=true in `/src/settings/projectSetting.ts`.',
	},
	exception: {
		backLogin: 'Back Login',
		backHome: 'Back Home',
		subTitle403: "Sorry, you don't have access to this page.",
		subTitle404: 'Sorry, the page you visited does not exist.',
		subTitle500: 'Sorry, the server is reporting an error.',
		noDataTitle: 'No data on the current page.',
		networkErrorTitle: 'Network Error',
		networkErrorSubTitle: 'Sorry，Your network connection has been disconnected, please check your network!',
	},
	lock: {
		unlock: 'Click to unlock',
		alert: 'Lock screen password error',
		backToLogin: 'Back to login',
		entry: 'Enter the system',
		placeholder: 'Please enter the lock screen password or user password',
	},
	login: {
		backSignIn: 'Back sign in',
		mobileSignInFormTitle: 'Mobile sign in',
		qrSignInFormTitle: 'Qr code sign in',
		signInFormTitle: 'Sign in',
		signUpFormTitle: 'Sign up',
		forgetFormTitle: 'Reset password',

		signInTitle: 'Backstage management system',
		signInDesc: 'Enter your personal details and get started!',
		policy: 'I agree to the xxx Privacy Policy',
		scanSign: `scanning the code to complete the login`,

		loginButton: 'Sign in',
		registerButton: 'Sign up',
		rememberMe: 'Remember me',
		forgetPassword: 'Forget Password?',
		otherSignIn: 'Sign in with',

		// notify
		loginSuccessTitle: 'Login Successful',
		loginSuccessDesc: 'Hello! Welcome to Polaris Systems',

		// placeholder
		accountPlaceholder: 'Please input username',
		passwordPlaceholder: 'Please input password',
		smsPlaceholder: 'Please input sms code',
		mobilePlaceholder: 'Please input mobile',
		policyPlaceholder: 'Register after checking',
		diffPwd: 'The two passwords are inconsistent',

		userName: 'Username',
		password: 'Password',
		confirmPassword: 'Confirm Password',
		email: 'Email',
		smsCode: 'SMS code',
		mobile: 'Mobile',

		yuanMiMa: 'Old Password',
		xinMiMa: 'New Password',
	},
	queRenMiMa: '确认密码',
	xiuGaiYongHuMiMa: '修改用户当前密码',
	xiTongGuanLi: 'system Manage',
	yunYingYongHuGuanLi: '运营用户管理',
	keHuYongHuGuanLi: '客户用户管理',
	souSuoNeiRong: 'Search User Management Content',
	yongHuZhangHao: 'Account',
	qingshuruyonghuzhanghao: 'Enter User Account',
	yongHuXingMing: 'Person',
	qingshuruyongHuXingMing: 'Enter User Person',
	lianXiDianHua: 'Phone No.',
	qingshuruyonghushoujihao: 'Enter User Phone No.',
	keHujiancheng: '客户简称',
	qingshuruyonghuzhaungtai: 'Enter User Status',
	yongHuZhuangTai: 'Status',
	zuiHouDengLuShiJian: 'Last Login',
	zaiZhi: 'Active',
	fuzhi: 'Copy',
	liZhi: 'Inactive',
	xingBie: 'Gender',
	nan: 'M',
	nv: 'F',
	tiShi: 'Tip',
	xuHao: '序号',
	queDingLizhi: '确定设定该用户离职吗',
	queDingZaiZhi: '确定设定该用户在职吗',
	queDingDelete: '确定删除该客户么',
	queDingQiyong: '确定启用该客户么',
	zhuangTai: '状态',
	constract: ' Contact Number',
	managerNumber: '管理员账号',
	chongZhiMiMa: 'Reset Password',
	quedingyaofuzhigaiyonghuma: '确定复制该用户吗?',
	quedingyaobianjigaiyonghuma: '确定编辑该用户吗?',
	quedingyaoxinzenggaiyonghuma: '确定新增该用户吗?',
	denglu: 'Login',
	workbench: '工作台',
	analysis: '分析页',
	dashboard: 'Dashboard',
	wushuju: 'No Data',
	xianggang: 'Hong Kong',
	zhongguo: 'China'
};
